import { inverterInfo } from '../models';
import { ListParams, ResponseData } from './../models/common';
import axiosClient from './axiosClient';

const urlApi = '/api/v1/inverter';
export const InverterApi = {
  fetchInverterInfo(param: ListParams): Promise<inverterInfo> {
    const url = `${urlApi}?${param.type}=${param.id}`;
    return axiosClient.get(url);
  },

  fetchInverterConfig(param: ListParams): Promise<any> {
    const url = `/api/v1/page-config?page_name=${param.name}&device_type=${param.type}`;
    return axiosClient.get(url);
  },
  fetchDataInverterGraph(param: ListParams): Promise<any> {
    const url = `/api/v1/timeseries?entity_type=DEVICE&entity_id=${param.id}&keys=${param.text}&start_ts=${param.start_ts}&end_ts=${param.end_ts}&limit=500&aggregate=MAX&duration=${param.duration}&order=ASC`;
    return axiosClient.get(url);
  },

  fetchStatisticByDevice(param: ListParams): Promise<any> {
    const url = `/api/v1/latest-timeseries?entity_type=DEVICE&entity_id=${param.id}&keys=${param.text}`;
    return axiosClient.get(url);
  },

  fetchStatisticByTime(param: ListParams): Promise<ResponseData[]> {
    const url = `${urlApi}-dashboard/${param.type}/${param.typeTime}?inverter_id=${param.id}&date=${param.dateTime}`;
    return axiosClient.get(url);
  },

  update(data: Partial<inverterInfo>): Promise<string> {
    const url = `${urlApi}?inverter_id=${data.id}`;
    return axiosClient.put(url, data);
  },
};
